import React from 'react';

import { Domain, Skill } from '@test_prep/app/ai_tutor/types';

import GradientPill from '../gradient_pill';
import { iconForSkill } from '../icons';

interface Props {
  domain: Domain;
  skill: Skill;
}

const LaunchAvailableSkillButton: React.FC<Props> = (props) => {
  const launchTutor = () => {
    const launchTutorEvent = new CustomEvent(
      'aiTutor.launchSkill',
      {
        detail: { domain: props.domain, initialSkill: props.skill }
      }
    );
    document.dispatchEvent(launchTutorEvent);
  };

  const IconForSkill = iconForSkill(props.domain, props.skill);

  return (
    <div onClick={launchTutor} style={{ cursor: 'pointer', display: 'inline-block' }}>
      <GradientPill size="sm">
        <IconForSkill size={14} /> {props.skill?.name || props.domain.name}
      </GradientPill>
    </div>
  );
};

export default LaunchAvailableSkillButton;
